// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msg-body {
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.msg-body a {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-messenger/sem-messenger.component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".msg-body {\n    white-space: pre-wrap;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n}\n\n.msg-body a {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
